import IconBreak from '@apollo/icons/default/IconBreak.svg';
import IconCheck from '@apollo/icons/default/IconCheck.svg';
import IconClose from '@apollo/icons/default/IconClose.svg';
import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import { useInternalGraphLinking } from 'src/app/graph/hooks/useInternalGraphLinking';
import { ProposalChangeMismatchSeverity } from 'src/lib/graphqlTypes/types';
import { useLDFlag } from 'src/lib/launchDarkly';

export const ProposalCheckDiffItemButton = ({
  hasApprovedProposal,
  linkableCoordinateName,
  severityLevel,
  subgraphName,
  isDescription,
}: {
  hasApprovedProposal: boolean;
  linkableCoordinateName: string;
  severityLevel: ProposalChangeMismatchSeverity;
  subgraphName: string;
  isDescription: boolean;
}) => {
  const { currentProposalCheckDetailsRoute } = useInternalGraphLinking();

  const location = useLocation();

  const shouldDescriptionsWarn = useLDFlag(
    'gov-proposal-checks-descriptions-warn',
  );

  return (
    <Link
      to={currentProposalCheckDetailsRoute.locationFrom({
        location,
        patch: {
          linkedSubgraphName: subgraphName,
          linkedCoordinateName: linkableCoordinateName,
          isDescription,
        },
      })}
      className={classnames(
        'focus-visible:focus-ring flex h-[18px] w-8 items-center justify-center rounded-r-full border',
        hasApprovedProposal && 'border-success bg-success',
        !hasApprovedProposal &&
          severityLevel === ProposalChangeMismatchSeverity.ERROR &&
          !isDescription &&
          'border-error bg-error',
        !hasApprovedProposal &&
          severityLevel === ProposalChangeMismatchSeverity.ERROR &&
          isDescription &&
          (shouldDescriptionsWarn
            ? 'border-warning bg-warning'
            : 'border-error bg-error'),
        !hasApprovedProposal &&
          severityLevel === ProposalChangeMismatchSeverity.WARN &&
          'border-warning bg-warning',
      )}
    >
      {hasApprovedProposal ? (
        <IconCheck className="size-3.5 text-icon-success" />
      ) : (severityLevel === ProposalChangeMismatchSeverity.ERROR &&
          !shouldDescriptionsWarn) ||
        isDescription === false ? (
        <IconClose className="text-icon-error" />
      ) : (
        <IconBreak className="text-icon-primary" />
      )}
    </Link>
  );
};
